<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" width="65%">
      <span slot="title" class="code-title">单据详情</span>
      <div class="order-info-box" v-loading="loading">
        <div class="order-info-item">
          <div class="order-info-item-title">单据信息</div>
          <div class="order-info-item-content">
            <span>单据类型：</span>
            <EllipsisTooltip
              :content="orderInfo.orderClassName"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.orderClassName }}
            </EllipsisTooltip>
          </div>
          <div class="order-info-item-content">
            <span>单据时间：</span>
            <EllipsisTooltip
              :content="orderInfo.orderTime"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.orderTime }}
            </EllipsisTooltip>
          </div>
          <div class="order-info-item-content">
            <span>采集时间：</span>
            <EllipsisTooltip
              :content="orderInfo.recTime"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.recTime }}
            </EllipsisTooltip>
          </div>
        </div>
        <div class="order-info-item">
          <div class="order-info-item-title">发货信息</div>
          <div class="order-info-item-content">
            <span>发货机构：</span>
            <EllipsisTooltip
              :content="orderInfo.shippedEnterpriseName"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.shippedEnterpriseName }}
            </EllipsisTooltip>
          </div>
          <div class="order-info-item-content">
            <span>地理位置：</span>
            <EllipsisTooltip
              :content="orderInfo.shippedLocation"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.shippedLocation }}
            </EllipsisTooltip>
          </div>
          <div class="order-info-item-content">
            <span>发货地址：</span>
            <EllipsisTooltip
              :content="orderInfo.shippedAddress"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.shippedAddress }}
            </EllipsisTooltip>
          </div>
        </div>
        <div class="order-info-item">
          <div class="order-info-item-title">委托信息</div>
          <div class="order-info-item-content">
            <span>储运机构：</span>
            <EllipsisTooltip
              :content="orderInfo.transportEnterpriseName"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.transportEnterpriseName }}
            </EllipsisTooltip>
          </div>
          <div class="order-info-item-content">
            <span>地理位置：</span>
            <EllipsisTooltip
              :content="orderInfo.transportLocation"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.transportLocation }}
            </EllipsisTooltip>
          </div>
          <div class="order-info-item-content">
            <span>储运地址：</span>
            <EllipsisTooltip
              :content="orderInfo.transportAddress"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.transportAddress }}
            </EllipsisTooltip>
          </div>
        </div>
        <div class="order-info-item">
          <div class="order-info-item-title">收货信息</div>
          <div class="order-info-item-content">
            <span>收货机构：</span>
            <EllipsisTooltip
              :content="orderInfo.receivedEnterpriseName"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.receivedEnterpriseName }}
            </EllipsisTooltip>
          </div>
          <div class="order-info-item-content">
            <span>地理位置：</span>
            <EllipsisTooltip
              :content="orderInfo.receivedLocation"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.receivedLocation }}
            </EllipsisTooltip>
          </div>
          <div class="order-info-item-content">
            <span>收货地址：</span>
            <EllipsisTooltip
              :content="orderInfo.receivedAddress"
              class="order-info-item-content-tip"
            >
              {{ orderInfo.receivedAddress }}
            </EllipsisTooltip>
          </div>
        </div>
      </div>
      <div class="order-search-box">
        <div class="order-search-title">单据明细</div>
        <div class="order-search-item-box">
          <div class="order-search-item-input">
            <el-input
              v-model="queryParam.keywords"
              placeholder="请输入药品名称/批次号"
              size="mini"
              style="width: 100%"
              @keyup.enter.native="handleSearch"
            />
          </div>
          <div class="order-search-button">
            <el-button type="primary" size="mini" @click="handleSearch"
              >查询</el-button
            >
            <el-button plain size="mini" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>
      <div class="order-table-box">
        <div class="table-box">
          <div class="table-d">
            <el-table
              ref="workTableRef"
              :data="tableList"
              stripe
              :header-cell-style="{
                background: '#F0F3F7',
                color: '#2a354e',
                fontWeight: 400,
              }"
              style="width: 98%; margin: 0 auto"
              height="300"
              @sort-change="handleSortChange"
              size="mini"
              v-loading="loading"
              highlight-current-row
              :row-key="'id'"
              @row-click="handleRowClick"
            >
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <span
                    style="color: #4076f2; cursor: pointer"
                    @click="handleTableCode(scope.row)"
                    >追溯码详情</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="commonName"
                label="药品通用名"
                width="250"
              />
              <el-table-column
                prop="quantity"
                label="数量"
                width="150"
                :show-overflow-tooltip="true"
                sortable="custom"
              />
              <el-table-column
                prop="dosageForm"
                label="剂型"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="drugSpecification"
                label="制剂规格"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="packageSpecification"
                label="包装规格"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="batchNo"
                label="生产批号"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="producedDateStr"
                label="生产日期"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="expiredDateStr"
                label="有效期至"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="nationalDrugCode"
                label="国家药品标识码"
                width="150"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.nationalDrugCodeException"
                    class="table-exception"
                    @click="handleTableException(scope.row)"
                  >
                    <span>异常</span>
                    <i class="el-icon-arrow-right" />
                  </div>
                  <div v-else>{{ scope.row.nationalDrugCode }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="quotedHolder"
                label="上市持有人"
                width="250"
              />
              <el-table-column
                prop="produtionEnterpriseName"
                label="生产企业"
                width="250"
              />
              <el-table-column
                prop="drugRegistTypeStr"
                label="注册分类"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                prop="specialDrugTypeStr"
                label="药品标识"
                width="150"
                :show-overflow-tooltip="true"
              />
              <el-table-column label="药检报告" width="100">
                <template slot-scope="scope">
                  <span
                    v-if="!scope.row.drugInspectionReportPdf"
                    style="color: #606266"
                    >查看</span
                  >
                  <span
                    v-else
                    style="color: #4076f2; cursor: pointer"
                    @click="handleTableDetail(scope.row)"
                    >查看</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="table-page">
            <div class="table-page-index">当前 {{ paging.index }} 页</div>
            <el-pagination
              :current-page="paging.index"
              :page-size="paging.size"
              layout="total,  prev, pager, next, jumper"
              :total="total"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </el-dialog>

    <Code ref="codeRef" />
    <TipDialog ref="TipDialogRef" class="TipDialog" />
  </div>
</template>

<script>
import EllipsisTooltip from "@/components/EllipsisTooltip";
import Code from "@/components/CodeList";
import TipDialog from "@/components/TipDialog/index.vue";

export default {
  name: "OrderDetail",
  components: {
    EllipsisTooltip,
    Code,
    TipDialog,
  },
  props: {},
  data() {
    return {
      loading: false,
      dialogCodeVisible: false,
      paging: {
        index: 1,
        size: 100,
      },
      queryParam: {
        orderId: "",
        partitionIndex: "",
        orderTable: "",
        keywords: "",
        enterpriseName: "",
        orders: {
          quantity: false,
        },
      },
      total: 0,
      tableList: [],
      orderInfo: {},
      selectedRow: null,
    };
  },
  created() {},
  methods: {
    handleRowClick(row) {
      this.selectedRow = row;
    },
    handleSortChange(value) {
      if (value.prop === "quantity") {
        if (!value.order) {
          // 默认
          this.queryParam.orders.quantity = false;
        }
        if (value.order === "ascending") {
          // 正序
          this.queryParam.orders.quantity = true;
        }
        if (value.order === "descending") {
          // 倒序
          this.queryParam.orders.quantity = false;
        }
      }
      this.paging.index = 1;
      this.getList();
    },
    handleTableException(row) {
      this.$refs.TipDialogRef.show({
        title: row.exceptionTitle,
        content: row.exceptionContent,
      });
    },
    handleTableCode(value) {
      this.$refs.codeRef.show({
        orderDetailId: value.orderDetailId,
        batchNo: value.batchNo,
        partitionIndex: value.partitionIndex,
        enterpriseName: this.queryParam.enterpriseName,
      });
    },
    async show(value) {
      this.dialogCodeVisible = true;
      this.loading = true;
      this.queryParam.orderId = value.id;
      this.queryParam.partitionIndex = value.partitionIndex;
      this.queryParam.orderTable = value.orderTable;
      this.queryParam.enterpriseName = value.enterpriseName;
      const { data, extended } =
        await this.$api.stock.GetStockBatchOrderListDetail({
          ...this.queryParam,
          paging: this.paging,
        });
      this.loading = false;
      this.tableList = data.details;
      this.orderInfo = data;
      this.total = extended.paging.total;
    },
    async getList() {
      this.loading = true;
      const { data, extended } =
        await this.$api.stock.GetStockBatchOrderListDetail({
          ...this.queryParam,
          paging: this.paging,
        });
      this.loading = false;
      this.tableList = data.details;
      this.orderInfo = data;
      this.total = extended.paging.total;
    },
    handleSearch() {
      this.paging.index = 1;
      this.getList();
    },
    handleReset() {
      this.queryParam.keywords = "";
    },
    handleSizeChange(value) {
      this.paging.index = 1;
      this.paging.size = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.paging.index = value;
      this.getList();
    },
    handleTableDetail(value) {
      window.open(value.drugInspectionReportPdf, "_blank");
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
::v-deep .TipDialog .el-dialog__header {
  background: #fff !important;
  border-bottom: none !important;
  padding: 20px !important;
  padding-bottom: 10px !important;
}
::v-deep .TipDialog .el-dialog__body {
  padding: 30px 20px !important;
}
</style>
<style lang="scss" scoped>
@import "./index.scss";
</style>
